import { OfficeError } from "./models/officeError";

export function getHtmlBodyAsync(item: Office.MessageCompose): Promise<string> {
  return new Promise((resolve, reject) => {
    item.body.getAsync(Office.CoercionType.Html, (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve(result.value);
      } else {
        const error: OfficeError = new OfficeError(result.error.code, result.error.message);
        reject(error);
      }
    });
  });
}

export function getSubjectAsync(item: Office.MessageCompose): Promise<string> {
  return new Promise((resolve, reject) => {
    item.subject.getAsync((result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve(result.value);
      } else {
        const error: OfficeError = new OfficeError(result.error.code, result.error.message);
        reject(error);
      }
    });
  });
}
